import { render, staticRenderFns } from "./MessageGroupIcon.vue?vue&type=template&id=49b19b20"
import script from "./MessageGroupIcon.vue?vue&type=script&lang=js"
export * from "./MessageGroupIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports